import { httpRequest } from "../../http";
import { brandTypographyStylesUrl } from "./cmdGetBrandTypographyStyles";

export class CommandArchiveBrandTypographyStyle {
    async run(organizationId: string, brandId: string, styleId: number) {
        const url = `${brandTypographyStylesUrl(organizationId, brandId)}${styleId}/`;
        return await httpRequest<string>(url, { method: "DELETE" });
    }
}
